<div class="p-10 animate-fade">
  <nz-alert class="animate-fade-left" *ngIf="eventosSeleccionados.length > 0" [nzMessage]="mensajeEventosSeleccionados" nzType="info" nzShowIcon>
  </nz-alert>
  <nz-calendar (nzSelectChange)="selectChange($event)">
    <ul *nzDateCell="let date">
      <ng-container *ngIf="eventMap[obtenerFechaClave(date)] as eventosDelDia">
        <li *ngFor="let evento of eventosDelDia">
          <nz-badge *ngIf="translate.currentLang === 'es'"
          [nzStatus]="evento.tipo === 'partido' ? 'success' : 'processing'"
          [nzText]="evento.tipo === 'partido' ? evento.descripcion : 'Entrenamiento: ' + evento.descripcion"
          ></nz-badge>
          <nz-badge *ngIf="translate.currentLang === 'gb'"
          [nzStatus]="evento.tipo === 'partido' ? 'success' : 'processing'"
          [nzText]="evento.tipo === 'partido' ? evento.descripcion : 'Training ' + evento.descripcion"
          ></nz-badge>
        </li>
      </ng-container>
    </ul>
  </nz-calendar>
</div>
